import type { CsvColumnMapping } from "../api/workItems";

export type PartialCsvMapping = Partial<Record<keyof CsvColumnMapping, number>>;

export const parseCsv = (text: string): string[][] => {
  const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
  return lines.map((line) => {
    const cells: string[] = [];
    let inQuote = false;
    let current = "";
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') {
        if (inQuote && line[i + 1] === '"') {
          current += '"';
          i++;
        } else {
          inQuote = !inQuote;
        }
      } else if (ch === "," && !inQuote) {
        cells.push(current.trim());
        current = "";
      } else {
        current += ch;
      }
    }
    cells.push(current.trim());
    return cells;
  });
};

export const buildCsvMapping = (
  partial: PartialCsvMapping,
): CsvColumnMapping | null => {
  if (partial.title === undefined) return null;
  const mapping: CsvColumnMapping = { title: partial.title };
  if (partial.description !== undefined)
    mapping.description = partial.description;
  if (partial.item_type !== undefined) mapping.item_type = partial.item_type;
  if (partial.status !== undefined) mapping.status = partial.status;
  if (partial.priority !== undefined) mapping.priority = partial.priority;
  return mapping;
};
